import {Shape} from "@/includes/parse_psd_data/psd-types/shape";

export class Rectangle extends Shape {}
